import {
  GETTING_VEHICLE_MAKE_AND_MODEL,
  VEHICLE_MODEL_INFO,
  GET_VEHICLE_MODEL_INFO,
  UPDATE_VEHICLE_INFO,
  UPDATE_PROPERTY_INFO,
} from '../actions/actionTypes';

import {
  ALL_CAR_MAKES,
  ALL_CATEGORIES,
  SEDAN,
  CL,
  RLX,
  TLX,
  INTEGRA,
  TL,
} from '../constants/Dashboard/Financing/auto';

const DEFAULT_STATE = {
  ALL_CAR_MAKES,
  MODELS: [RLX, CL, INTEGRA, TLX, TL],
  YEARS: [
    2000, 2001, 2002, 2003, 2004, 2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015,
    2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026,
  ],
  AUTO_TYPES: ALL_CATEGORIES,
  loading: false,
  make: ALL_CAR_MAKES[0],
  model: RLX,
  year: 2026,
  auto_type: SEDAN,
  estimateValue: 40000,
  downPayment: 8000,
};

export const vehicleReducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case GETTING_VEHICLE_MAKE_AND_MODEL:
      return {
        ...state,
        loading: true,
      };

    case VEHICLE_MODEL_INFO:
      return {
        ...state,
        loading: false,
        MAKE_INFO: action.payload.restructureData,
        MODELS: action.payload.restructureData.models,
        YEARS: action.payload.restructureData.years || DEFAULT_STATE.YEARS,
        AUTO_TYPES: action.payload.restructureData.auto_types,
        model: action.payload.restructureData.model,
        year: action.payload.restructureData.year,
        auto_type: action.payload.restructureData.auto_type,
      };

    case GET_VEHICLE_MODEL_INFO:
      const allYears = Object.keys(state['MAKE_INFO'][action.payload]?.years);
      return {
        ...state,
        model: action.payload,
        year: allYears[allYears.length - 1],
        YEARS: allYears,
        AUTO_TYPES: Object.keys(state['MAKE_INFO'][action.payload]?.auto_types || {}),
        auto_type: Object.keys(state['MAKE_INFO'][action.payload]?.auto_types)?.[0],
      };

    case UPDATE_VEHICLE_INFO:
      return {
        ...state,
        ...action.payload,
      };

    case UPDATE_PROPERTY_INFO:
      // Setting the financingType to Home
      return {
        ...state,
        financingType: action.payload.financingType,
      };

    default:
      return {
        ...state,
      };
  }
};
